import React, {useCallback, useState, useMemo} from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';
import ExtraIcon from "../../../../assets/extra.png";
import EditIcon from '../../../../assets/edit.svg'
import {
	EmptyState,
	Loader,
	Table,
	DropDown, Modal, Button, SearchInput, Toast,
} from '@kaleyra/emmy';

import cn from 'classnames';
import {Helmet} from "react-helmet";
import AddIcon from "../../../../assets/AddWhite.svg";
import {debounce} from "lodash";
import {useHistory} from "react-router-dom";
import {date12HrFormat} from "../../../../utils";

export type MapStateType = {
	data: any;
	page: number;
	total: number;
	inProgress: boolean;
	appliedFilters: Record<string, any>;
	globalTotal: number;
	paginationInProgress: boolean;
};

export type DispatchPropsType = {
	onPaginate: () => void;
	initializeAndLoadData: (
		filters?: Record<string, any>,
		searchTerm?: string,
		dynamicUrlData?:string
	) => void;
	removeInstance: () => void;
	openAddModal: (params:any) => void;
	openRenameModal: (params:any) => void;
	onSearchTextChange: (searchText: string,dynamicUrlData:string) => void;
	removeSipAclInstance : () => void;
	onDelete: ( dynamicUrlData: string, keyForIdentifier:string, cb?:(res: any, success: boolean)=> void ) => void;
	editSipAcl: ( reqData:any,keyForIdentifier:string, dynamicUrl:string, cb?:(res: any, success: boolean)=> void ) => void;
};
type params = {
	match:any
}
type PropsType = MapStateType & DispatchPropsType & params;

const SipIP: React.FC<PropsType> = (
	{
		data,
		page,
		total,
		inProgress,
		onPaginate,
		initializeAndLoadData,
		globalTotal,
		paginationInProgress,
		removeInstance,
		openAddModal,
		openRenameModal,
		onSearchTextChange,
		onDelete,
		editSipAcl,
		removeSipAclInstance
	}) => {
	const { t } = useTranslation();
	const history:any = useHistory();
	if(!history?.location?.state?.ip_acl_id) history.push("/channels/voice/sip-acl");
	const [selectedSipAcl,setSipAclData] = useState<Record<string, any>>({});
	const [selectedIP, setSelectedIP] = useState<any>({});
	const [deleteIP, setDeleteIP] = useState(false);
	const [searchText, setSearchText] = useState('');

	React.useEffect(() => {
		if(!history?.location?.state?.ip_acl_id) return history.push("/channels/voice/sip-acl");
		setSipAclData(history.location.state);
		initializeAndLoadData(
			{
				ip_acl_id: history.location.state.ip_acl_id},
			"username"
		);
		return () => {
			removeInstance();
			removeSipAclInstance();
		}
	}, []);

	const handleIPDelete = useCallback( (id: string) => {
		onDelete(id,"credential_id",
			(res:any,success:boolean)=>{
				if(success) Toast(t('KLR00489'),'success') //todo change success message
			});
	},[]);
	const renderDeleteIPModal = useCallback( () => {
		return (
			<Modal
				title={t('KLR00703')}
				body={t('KLR00463',{name:selectedIP?.ip_address||""})}
				visible={deleteIP}
				footer={
					<div>
						<span style={{ marginRight: '1rem' }}>
							<Button
								type="tertiary"
								onClick={() => setDeleteIP(false)}
							>
								{t('mainCancel')}
							</Button>
						</span>
						<Button
							type="danger"
							onClick={() => {
								handleIPDelete(selectedIP.id);
								setDeleteIP(false);
							}}
						>
							{t('mainYesDelete')}
						</Button>
					</div>
				}
			/>
		);
	},[deleteIP,setDeleteIP]);

	const handleRenameSipAcl = (title:string)=>{
		setSipAclData(prevState => ({ ...prevState, title }));
		editSipAcl(
			{
				ip_acl_name : title
			},
			"ip_acl_id",
			selectedSipAcl.ip_acl_id,
			(res:any,success:boolean)=>{
				if(success){
					setSipAclData((prevState:Record<string, any>) => {
						return {
							...prevState,
							ip_acl_name: res.data.ip_acl_name
						};
					});
					Toast(t('KLR00711'),'success');
				}else{
					console.log("Error");
				}
			}
			);
	}
	const renderTopBar = useMemo(() => {
		return (
			<div>
				<div className={Styles.heading}>
					{`${selectedSipAcl.ip_acl_name}`}
					<span className={Styles.editIcon} onClick={()=>openRenameModal({
						title:selectedSipAcl?.ip_acl_name,
						handleRenameSipAcl
					})}>
						<img src={EditIcon} alt={"Edit Icon"}/>
					</span>
				</div>
				<div>
					<div className={Styles.subHeading}>{t('KLR00706')}</div>
					<div className={Styles.domainList}>
						{selectedSipAcl?.domains?.slice(0,2).join(', ')}
						{selectedSipAcl?.domains?.length > 2 && <span className={Styles.domainCount}>+{selectedSipAcl?.domains?.length-2}</span>}
					</div>
				</div>
				<div className={Styles.mainHeading}>{t('KLR00704')}</div>
			</div>
		)
	},[selectedSipAcl])

	const debouncedChange = React.useCallback(
		debounce((value:any = "") => {
			onSearchTextChange(value,selectedSipAcl.ip_acl_id);
		}, 400),
		[selectedSipAcl]
	);

	inProgress = false;
	globalTotal = 5;
	data = [
		{
			"ip_addr_id": "SG_a461b8fe-463a-4f2f-8ef7-3a28268e2199",
			"ip_address": "111.98.0.0",
			"created_at": "2021-10-18T07:31:00.743Z"
		},
		{
			"ip_addr_id": "SG_a461b8fe-463a-4f2f-8ef7-3a28268e2188",
			"ip_address": "202.79.235.225",
			"created_at": "2021-10-17T07:31:00.743Z"
		},
		{
			"ip_addr_id": "SG_a461b8fe-463a-4f2f-8ef7-3a28268e2177",
			"ip_address": "127.0.0.1",
			"created_at": "2021-10-20T17:31:00.743Z"
		},
		{
			"ip_addr_id": "SG_a461b8fe-463a-4f2f-8ef7-3a28268e2166",
			"ip_address": "10.10.10.100",
			"created_at": "2021-10-15T13:31:00.743Z"
		},
		{
			"ip_addr_id": "SG_a461b8fe-463a-4f2f-8ef7-3a28268e2155",
			"ip_address": "10.20.30.52",
			"created_at": "2021-10-13T07:45:00.743Z"
		},
		{
			"ip_addr_id": "SG_a461b8fe-463a-4f2f-8ef7-3a28268e2144",
			"ip_address": "121.988.12.12",
			"created_at": "2021-10-18T07:31:00.743Z"
		}
	]
	const getColumns = () => {
		return [
			{
				accessor: 'ip_address',
				header: t('KLR00704'),
				width: '45%',
			},
			{
				accessor: 'created_at',
				header: t('KLR00707'),
				width: '45%',
				Cell:(tableData:any)=>{
					const { original } = tableData;
					return <span>{date12HrFormat(original.created_at,false,"",false,true)}</span>
				}
			},
			{
				header: t(''),
				accessor: '',
				width:"10%",
				Cell: (tableData: any) => {
					const { original } = tableData;
					return (
						<DropDown
							items={[
								{
									label: t('mainDelete'),
									value: 'delete',
								},
							]}
							action={(operation: any) => {
								if (operation === 'delete') {
									setSelectedIP(original);
									setDeleteIP(true);
								}
							}}
							placement="bottom"
							trigger={['click']}
						>
							<img
								src={ExtraIcon}
								id={original?.id}
								className={Styles.dotsImg}
							/>
						</DropDown>
					);
				},
			},
		];
	};
	return (
		<div className={Styles.container}>
			<Helmet>
				<title>{t('KLR00439')}</title>
			</Helmet>
		{ (inProgress || globalTotal == null || globalTotal == undefined) ? <Loader/>	:
			(
				<>
					{ renderTopBar }
					{globalTotal > 0 && (
						<>
							<div className={cn(Styles.searchContainer)}>
								<SearchInput
									className={Styles.searchInput}
									eachChar={true}
									placeholder={t('mainSearch')}
									label={t('mainSearch')}
									searchStr={searchText}
									onChange={(value: any) => {
										setSearchText(value);
										debouncedChange(value);
									}}
								/>

								<span
									className={Styles.addBtn}
								>
									<Button
										type="primary"
										onClick={() =>
											openAddModal({
												aclData:selectedSipAcl,
												onlyAddIpAddresses:true
											})
										}
										icon={<img src={AddIcon} />}
										iconPosition="left"
									>
										{t('KLR00499')}
									</Button>
								</span>
							</div>
						</>
					)}
					{ (globalTotal === 0)?
					<EmptyState
						bordered
						smallBorder={true}
						showButton={false}
						logStyle={true}
						labelForLogStyle={t('KLR00478')}
					/> :
					<Table
						columns={getColumns()}
						data={data}
						page={page + 1}
						pageSize={25}
						manual
						onPaginate={onPaginate}
						total={total}
						inProgress={paginationInProgress}
						labelForNoResult={t('KLR00477')}
						labelForNoResultDesc={t('KLR00478')}
						rowClassName={Styles.SATable}
					/>}
				</>
			)
		}
			{renderDeleteIPModal()}
		</div>
	);
};

export default SipIP;
